import {Map} from 'immutable';

import {
  SET_GEOFENCE
} from './actions';

const geofence = (state = Map({ geofencesMap: Map() }), action) => {
    switch (action.type) {
      case SET_GEOFENCE:
        return state.setIn(['geofencesMap', action.payload.geofence._id], action.payload.geofence);
      default:
        return state;
    }
};

export default geofence;


// WEBPACK FOOTER //
// ./src/Geofence/reducers.js